/**
 * Shared money formatting (L10). One place instead of per-page symbol maps:
 * Intl gives the right symbol/format for any ISO currency, with a safe
 * fallback for unknown codes.
 */

export function formatMoney(minorUnits, currency = 'GBP', options = {}) {
  const amount = (Number(minorUnits) || 0) / 100;
  try {
    return new Intl.NumberFormat('en-GB', { style: 'currency', currency, ...options }).format(amount);
  } catch (err) {
    return `${currency} ${amount.toLocaleString('en-GB', { minimumFractionDigits: 2 })}`;
  }
}

export function formatMajorMoney(amount, currency = 'GBP', options = {}) {
  try {
    return new Intl.NumberFormat('en-GB', { style: 'currency', currency, ...options }).format(Number(amount) || 0);
  } catch (err) {
    return `${currency} ${(Number(amount) || 0).toLocaleString('en-GB')}`;
  }
}
